import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Map, TileLayer } from 'react-leaflet'

import CharacterDropIn from '../components/CharacterDropIn'
import SwappableDiv from '../components/SwappableDiv'

import { swapDiv } from '../actions/actions'

class GraphistryMario extends Component {
    constructor(props) {
        super(props)
        this.DEFAULT_VIEWPORT = {
            center: [38.303065, -77.458153],
            zoom: 15,
        }
        this.state = {
            viewport: this.DEFAULT_VIEWPORT,
            showDiv: false,
        }
    }

    swapdiv = () => {
        this.props.dispatch( swapDiv() )
    }

    render() {
        return(
            <div>
                <nav className="pt-navbar">
                    <div className="pt-navbar-group pt-align-left">
                        <div className="pt-navbar-heading">
                            <b><CharacterDropIn value={'Jamal Mahboob: GraphistryMario Test'} /></b>
                        </div>
                    </div>
                    {/*<div className="pt-navbar-group pt-align-right">
                        <div className="pt-navbar-heading pt-button-group">
                            <button className="pt-button" onClick={() => this.setState({ showDiv: !this.state.showDiv })}>
                                {this.state.showDiv ? "Hide Text" : "Show Text"}
                            </button>
                            <button className="pt-button" onClick={this.swapdiv}>
                                Swap Div
                            </button>
                        </div>
                    </div>*/}
                </nav>

                { this.state.showDiv && <SwappableDiv /> }

                <div className="graphistry_left">
                    <iframe frameBorder={0} style={{width: '100%', height: '100%'}}
                        src="https://static.jamalmahboob.com/MarioASM.html"
                    />
                </div>
                <div className="graphistry_right">
                    <iframe frameBorder={0} style={{width: '100%', height: '100%'}} 
                        src="https://labs.graphistry.com/graph/graph.html?dataset=PyGraphistry%2FHA90QN7669&type=vgraph&viztoken=b5f602f60d57928891818b8b4b936bd35c63c2a3&usertag=6325d710-pygraphistry-0.9.51&info=true&workbook=4234239620bdeee4"
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps)(GraphistryMario)



// WEBPACK FOOTER //
// ./src/containers/GraphistryMario.js